const KEY = 'app_data';


class PersistStorage {

  constructor(key) {
    this.key = key;
    this.data = JSON.parse(window.localStorage.getItem(key) || '{}');
  }

  setValue(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
  };

  getValue(key, defaultValue = null) {
    const val = window.localStorage.getItem(key);

    try {
      return val === undefined ? defaultValue : JSON.parse(val);
    } catch (e) {
      return defaultValue;
    }
  };

  clear() {
    window.localStorage.clear();
  }
}

export const persistStorage = new PersistStorage(KEY);